import { GET_ORDERHISTORY,REFRESH_ORDERHISTORY } from '../actions'

export default function (state = 'loading', action) {
    switch (action.type) {
        case GET_ORDERHISTORY:
            if(action.error == true){
                return {success:false}
            }
            else{
                return action.payload.data.data
            }
        case REFRESH_ORDERHISTORY:
            return action.payload.data.data
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/orderhistory_reducer.js